import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, switchMap, throwError } from 'rxjs';
import { LOGIN, LOGIN_RESET, LOGIN_SUCCESS, LOGOUT } from './login.actions';
import { ApiService } from '../../services/api.service';
import { LoginPayload } from '../../interfaces/login-payload';
import { ILoginState } from './login';
import { setCookie,deleteCookie } from '@poste-click-connect/shared-ui';
import { Router } from '@angular/router';
import {
  RETRIEVE_EXPIRED_OBJECT,
  RETRIEVE_NOTIFICATIONS,
  RETRIEVE_REGEX_DHL,
  RETRIEVE_SURVEY,
} from '../config/config.actions';
import { LoginCode } from '../../enums/login-code.enum';
import { Path } from '../../enums/path.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ADD_MESSAGE } from '../messages/messages.actions';
import { InterceptorService } from '../../services/interceptor.service';
import { setModalError } from '../../utils/error-modal.utils'
import { LOGIN_OTP_PRELOAD, LOGIN_OTP_RESET } from '../login-otp/login-otp.actions';
import { CERTIFICA_EMAIL_PRELOAD } from '../certifica-email/certifica-email.actions';

@Injectable()
export class LoginEffects {
  retrieveProfilerUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGIN),
      switchMap((action) =>
        this.api.login(action.body).pipe(
          mergeMap((responseLogin: ILoginState) => {

            const isNavigationAvailable =
              responseLogin.esito === LoginCode.AVAILABLE ||
              responseLogin.esito === LoginCode.CHANGE_PASSWORD ||
              responseLogin.esito === LoginCode.EMAIL_NOT_CERTIFIED ||
              responseLogin.esito === LoginCode.BOTH_CERTIFIED ||
              responseLogin.esito === LoginCode.PHONE_NOT_CERTIFIED ||
              responseLogin.esito === LoginCode.BOTH_NOT_CERTIFIED;

            const isExcluded = responseLogin.esito === LoginCode.NOT_AVAILABLE;
            const isSuspended = responseLogin.esito === LoginCode.SUSPENDED;
            const isDisabled = responseLogin.esito === LoginCode.DISABLED;

            // Caso utente escluso (-2)
            if (isExcluded) {
              deleteCookie('accessToken', window.location.hostname);
              deleteCookie('servizi', window.location.hostname);
              deleteCookie('isLottomatica', window.location.hostname);

              this.interceptorService.errorModal = setModalError("LOGIN0001");
              this.interceptorService.showModalError = true;
              return [];
            }

            if (isSuspended) {
              deleteCookie('accessToken', window.location.hostname);
              deleteCookie('servizi', window.location.hostname);
              return [LOGIN_SUCCESS({ responseLogin })];
            }

            if (isDisabled) {
              deleteCookie('accessToken', window.location.hostname);
              deleteCookie('servizi', window.location.hostname);
              return [LOGIN_SUCCESS({ responseLogin })];
            }

            if (isNavigationAvailable) {
              const today = new Date();
              const expirationDate = today.getTime() + 500000;

              setCookie('accessToken', responseLogin.authToken, `${expirationDate}`, window.location.hostname);
              setCookie('servizi', JSON.stringify(responseLogin.servizi), `${expirationDate}`, window.location.hostname);

              if (responseLogin.esito === LoginCode.AVAILABLE) {
                this.interceptorService.isLoginCambioPassword = false;
                this.router.navigateByUrl('/');
              }

              if (responseLogin.esito === LoginCode.CHANGE_PASSWORD) {
                this.interceptorService.isLoginCambioPassword = true;
                this.router.navigateByUrl(`/${Path.CAMBIO_PASSWORD_SCADUTA}`);
              }

              if (responseLogin.esito === LoginCode.EMAIL_NOT_CERTIFIED) {
                if (responseLogin.mail) {
                  this.store.dispatch(CERTIFICA_EMAIL_PRELOAD({ email: responseLogin.mail}));
                }
                this.router.navigateByUrl(`/${Path.CERTIFICA_EMAIL}`);
              }
              if (responseLogin.esito === LoginCode.BOTH_CERTIFIED) {
                const telefonoCertificato = responseLogin.telefonoCertificato ?? '';
                this.store.dispatch(LOGIN_OTP_PRELOAD({ telefono: telefonoCertificato }));
                this.router.navigateByUrl(`/${Path.LOGIN_OTP_SEND}`);
              }

              if (responseLogin.esito === LoginCode.PHONE_NOT_CERTIFIED ||
                  responseLogin.esito === LoginCode.BOTH_NOT_CERTIFIED) {
                // DREQ0040573 - precarica la mail nello store per pre-compilare certifica-email
                if (responseLogin.esito === LoginCode.BOTH_NOT_CERTIFIED && responseLogin.mail) {
                  this.store.dispatch(CERTIFICA_EMAIL_PRELOAD({ email: responseLogin.mail }));
                }
                this.router.navigateByUrl(`/${Path.CERTIFICA_CELLULARE}`);
              }
            }

            return [
              LOGIN_SUCCESS({ responseLogin }),
              ...(isNavigationAvailable && responseLogin.esito === LoginCode.AVAILABLE
                ? [ RETRIEVE_NOTIFICATIONS(), RETRIEVE_SURVEY(), RETRIEVE_REGEX_DHL(), RETRIEVE_EXPIRED_OBJECT() ]
                : []),
            ];
          }),
          catchError((error: HttpErrorResponse) => {
            this.addErrorMessage(error.message)
            return throwError({ error });
          })
        )
      )
    )
  );


  retriveLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGOUT),
      switchMap(() => this.api.retriveLogout()),
      mergeMap(() => {
        return [
          LOGIN_RESET(),
          LOGIN_OTP_RESET(),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );
  

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store,
    private interceptorService: InterceptorService
  ) {}

  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
